import axios from 'axios';
import { useEffect, useRef } from 'react';
import { useGlobalState } from '../Contexts/GlobalStateContext';

export const useApi = () => {
  const { tempClientId, setLoading, setErrorVisible, setErrorMessage, setNetworkErrorVisible, voyceToken } = useGlobalState();
  const activeRequests = useRef(0);

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: {
      'Content-Type': 'application/json',
      'WEYIToken': voyceToken
    }
  });

  useEffect(() => {
    const handleRequestStart = (config) => {
      activeRequests.current += 1;
      setLoading(true);
      if (tempClientId) {
        config.headers['TempClientId'] = tempClientId;
      }
      return config;
    };

    const handleRequestEnd = () => {
      activeRequests.current -= 1;
      if (activeRequests.current === 0) {
        setLoading(false);
      }
    };

    const handleRequestError = (error) => {
      handleRequestEnd();
      if (error.code === "ERR_NETWORK") {
        setNetworkErrorVisible(true);
      } else {
        setErrorVisible(true);
        const message = error?.response?.data?.Message || error?.response?.data?.Description || error?.response?.data || 'An unknown error occurred';
        setErrorMessage(message);
      }
      return Promise.reject(error);
    };

    const handleResponse = (response) => {
      handleRequestEnd();
      return response;
    };

    const handleResponseError = (error) => {
      handleRequestEnd();
      if (error.code === "ERR_NETWORK") {
        setNetworkErrorVisible(true);
      } else {
        setErrorVisible(true);
        const message = error?.response?.data?.Message || error?.response?.data?.Description || error?.response?.data || 'An unknown error occurred';
        setErrorMessage(message);
      }
      return Promise.reject(error);
    };

    const reqInterceptor = api.interceptors.request.use(handleRequestStart, handleRequestError);
    const resInterceptor = api.interceptors.response.use(handleResponse, handleResponseError);

    return () => {
      api.interceptors.request.eject(reqInterceptor);
      api.interceptors.response.eject(resInterceptor);
    };
  }, [setLoading, setErrorVisible, setErrorMessage, tempClientId, setNetworkErrorVisible, api]);

  return api;
};
